var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIconsCashback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5970279,
    cx: 35.4863,
    cy: 35.6047,
    r: 34.5,
    stroke: "white",
    fillOpacity: 0.20648,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7278 29.1793H41.6028V31.4743H32.3328V29.1793H33.7578V27.0793H32.3328V25.3693H33.7578V25.2793C33.7578 23.8493 34.2028 22.7393 35.0928 21.9493C35.9928 21.1593 37.2528 20.7643 38.8728 20.7643C40.1028 20.7643 41.1228 20.9893 41.9328 21.4393L41.0628 23.7193C40.5028 23.3893 39.8228 23.2243 39.0228 23.2243C38.2828 23.2243 37.7128 23.3943 37.3128 23.7343C36.9228 24.0643 36.7278 24.5593 36.7278 25.2193V25.3693H40.1178V27.0793H36.7278V29.1793Z",
    id: "mask-fill-icon"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4003 38.9743L22.7812 45.3263L31.4003 51.6793V46.3273H46.7523V44.3263H31.4003V38.9743ZM25.7643 45.3263L29.6302 42.4783V48.1763L25.7643 45.3263Z",
    id: "mask-fill-icon"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconsCashback);
export default __webpack_public_path__ + "static/media/profile_icons_cashback.dc28e46b0a3c65e0d1a9a7d5278952c0.svg";
export { ForwardRef as ReactComponent };